import i18next from 'i18next'
import { create } from 'mobx-persist'
import moment from 'moment'
import 'moment/locale/fi'
import React from 'react'
import ReactDOM from 'react-dom'
import { initReactI18next } from 'react-i18next'
import authStore from '../auth/authStore'
import translations from '../i18n/translations.json'
import reminderStore from '../root/ReminderStore'
import Root from '../root/Root'
import stationStore from '../station/stationStore'
import noteStore from '../weeklyInfo/noteStore'
import './index.css'

moment.locale('fi')

i18next.use(initReactI18next).init({
  lng: 'fi',
  resources: translations,
  fallbackLng: 'fi',
  debug: false,
  interpolation: {
    escapeValue: true,
  },
})

export const i18n = i18next

const renderAppWithStore = async () => {
  const sessionPrefix = process.env.REACT_APP_SESSION_PREFIX as string
  await create()(`${sessionPrefix}.notes`, noteStore)
  await create()(`${sessionPrefix}.station`, stationStore)
  await create()(`${sessionPrefix}.auth`, authStore)
  await create()(`${sessionPrefix}.reminders`, reminderStore)

  ReactDOM.render(<Root />, document.getElementById('root'))
}

module?.hot?.accept()

renderAppWithStore()
